<div>
  <div class="d-flex align-items-center justify-content-space-between gap-16">
    <p class="p1">
      {{ 'Product on card:' | trans:'cards/card-details-modal/actions/products.Label' }}
    </p>

    <button
      class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
      (click)="addProductsModalComponent.open()"
    >
      <i class="ri-add-line"></i>
      {{ 'Add product' | trans:'cards/card-details-modal/actions/products/add-product-button.Label' }}
    </button>
  </div>

  <div class="m-t-24">
    @if (card.productsOnCard.length > 0) {
      <app-switch
        text="{{ 'Show used' | trans:'cards/card-details-modal/actions/products/showUsed.Text' }}"
        [(ngModel)]="showUsedItems"
      />

      <div class="m-t-16">
        @if ((card.productsOnCard | arrayFilter:(showUsedItems ? excludeUnusuedItems : excludeUsedItems)).length > 0) {
          <table class="base full-width">
            <thead>
            <tr>
              <th>
                {{ 'Product' | trans:'cards/card-details-modal/actions/products/product.Label' }}
              </th>
              <th>
                {{ 'Product group' | trans:'cards/card-details-modal/actions/products/group.Label' }}
              </th>
              <th>
                {{ 'Date used' | trans:'cards/card-details-modal/actions/products/dateUsed.Label' }}
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              @for (p of ((card.productsOnCard | arrayFilter:(showUsedItems ? excludeUnusuedItems : excludeUsedItems)) | arraySortByKey:(showUsedItems ? 'dateUsed' : 'productName'):(showUsedItems ? 'desc' : 'asc')); track p.id) {
                <tr>
                  <td>
                    <div
                      class="white-space-nowrap overflow-hidden text-overflow-ellipsis t4 text-uppercase fw-medium c-t-blue-700"
                    >
                      {{ p.productName }}
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ p.productGroupName }}
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ (p.dateUsed | localeDatetimeFormat) | empty }}
                    </div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center justify-content-flex-end">
                      @if (!p.dateUsed) {
                        <button
                          class="button button--icon-sm button--no-border c-t-nok-400"
                          appConfirmation
                          confirmationModalTitle="{{ 'Delete product' | trans:'cards/card-details-modal/actions/products/delete-product-confirmation-modal.Title' }}"
                          confirmationModalText="{{ 'Are you sure you want to delete this product?' | trans:'cards/card-details-modal/actions/products/delete-product-confirmation-modal.Text' }}"
                          (click)="$event.stopPropagation()"
                          (onConfirm)="deleteProductFromCard(p.cardProductId)"
                          appTooltip
                          content="{{ 'Delete product' | trans:'cards/card-details-modal/actions/products/delete-product-confirmation-modal.Tooltip' }}"
                        >
                          <i class="ri-close-circle-line"></i>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="text-center">
            {{ 'No data found' | trans:'app/tables/no-data-found.Label' }}
          </p>
        }
      </div>
    } @else {
      <p class="text-center">
        {{ 'No data found' | trans:'app/tables/no-data-found.Label' }}
      </p>
    }
  </div>
</div>

<app-add-products-modal
  #addProductsModalComponent
  [card]="card"
  (formFinished)="card = $event; cardUpdated.emit($event);"
/>
